export default __webpack_public_path__ + "static/media/Ripple.1cf8b83f.gif";